import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { RegistrarSecUsuarioRequest } from '../../shared/interfaces/database/seguridad';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SecUsuarioSolicitudService {
  private readonly baseUrl = `${environment.apiUrl}/api/sec-usuario-solicitud`;

  constructor(private http: HttpClient) { }

  createSecUsuarioSolicitud(request: RegistrarSecUsuarioRequest): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl, request);
  }
}
